import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import authService from '@/services/auth'
import Cookies from 'js-cookie'

const adminRoutes = [
  {
    path: '/configuracoes/aplicacoes',
    name: 'aplicacoes-lista',
    component: () => import('../views/admin/admin/projetos/ListaView.vue'),
  },
  {
    path: '/configuracoes/aplicacoes/:id',
    name: 'aplicacao',
    component: () => import('../views/admin/admin/projetos/ProjetoView.vue'),
  },
  {
    path: '/configuracoes/solicitacoes',
    name: 'solicitacoes',
    beforeEnter: [stgn2Prod, forceLogin],
    component: () => import('../views/admin/admin/solicitacoes/ListaView.vue'),
  },
  {
    path: '/configuracoes/solicitacao/:protocol',
    name: 'Finalizarsolicitacao',
    beforeEnter: [stgn2Prod, forceLogin],
    component: () => import('../views/admin/admin/solicitacoes/FinalizarSolicitacao.vue'),
  },

  {
    path: '/',
    name: 'admin-opcoes',
    component: () => import('../views/admin/AdminView.vue'),
  },
].map((item) => {
  item.path = '/admin' + item.path
  item.beforeEnter = (to, from, next) => {
    if (!useAuthStore().user?.isAdmin) next('/')
    next()
  }
  return item
})

function forceLogin(to, from, next) {
  if (!useAuthStore().token) {
    const urlToGo = useAuthStore().urlLogin('home', 'password', null, window.location.href)
    console.log('goto ' + decodeURIComponent(urlToGo))
    window.location.href = urlToGo
    return // impede o Vue Router de continuar
  }
  next()
}
function stgn2Prod(to, from, next) {
  if (import.meta.env.VITE_SENTRY_ENVIRONMENT === 'staging') {
    window.location.href = 'https://home.registrocivil.org.br/solicitacao'
    return // impede o Vue Router de continuar
  }
  next()
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/idrc',
      name: 'idrc',
      component: () => import('../views/IdRCView.vue'),
    },
    {
      path: '/solicitacao', //esta aqui para não travar o fluxo em homolog
      name: 'solicitacao',
      component: () => import('../views/SolicitacaoView.vue'),
      beforeEnter: [stgn2Prod, forceLogin],
    },
    {
      path: '/solicitacaonovoclient',
      name: 'solicitacao-novo-client',
      component: () => import('../views/SolicitacaoView.vue'),
      beforeEnter: [stgn2Prod, forceLogin],
    },
    {
      path: '/minhasSolicitacoes',
      name: 'minhas-solicitacoes',
      component: () => import('../views/MinhasSolicitacoesView.vue'),
      beforeEnter: [stgn2Prod, forceLogin],
    },
    {
      path: '/informacoesSolicitacao/:protocol',
      name: 'verificar-solicitacao',
      component: () => import('../views/SolicitacaoInfosView.vue'),
      beforeEnter: [stgn2Prod, forceLogin],
    },
    {
      path: '/solicitacaoAtualizarUrl',
      name: 'solicitacao-update-url',
      beforeEnter: [stgn2Prod, forceLogin],
      component: () => import('../views/SolicitacaoUpdateUrl.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginView.vue'),
    },
    {
      path: '/ciba',
      name: 'ciba',
      component: () => import('../views/CibaView.vue'),
    },
    {
      path: '/rc',
      name: 'login-rc',
      component: () => import('../views/LoginView.vue'),
      props: { platform: 'rc' },
    },
    {
      path: '/redeconsular',
      name: 'login-rede-consular',
      component: () => import('../views/LoginView.vue'),
      props: { platform: 'rede-consular' },
    },
    {
      path: '/',
      name: 'home',
      component: () => import('../views/ProjetosView.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('../views/ProjetosView.vue'),
    },

    ...adminRoutes,
  ],
})

router.beforeEach(async (to, from, next) => {
  const publicPages = ['/', '/solicitacao', '/login', '/rc', '/redeconsular', '/ciba']
  const loginPages = ['/login', '/rc', '/redeconsular', '/ciba']
  const authRequired = !publicPages.includes(to.path)

  const auth = useAuthStore()
  const { logout } = to.query

  const userSession = Cookies.get('has_user_session')
    ? JSON.parse(atob(Cookies.get('has_user_session'))).message
    : null

  if (logout) {
    await auth.logoutCallback()
    await next('/')
    return
  }

  if (auth.token || authRequired) {
    const authenticated = await auth.verifyLogin()

    if (!authenticated && authRequired) {
      await auth.logoutCallback()
      return next('/')
    }

    if (to.path === '/login') {
      await next('/')
      return
    }

    auth.user = await authService.getSelfData()
    return next()
  } else {
    Cookies.remove('has_user_session')
    if (!(userSession === false) && !loginPages.includes(to.path)) {
      const url = auth.urlLogin('home', 'password', 'none', window.location.href)
      return window.location.replace(url)
    }

    return next()
  }
})

export default router
